var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45965 8.99994L1.85645 11.1375C1.63245 11.4362 1.51992 11.8037 1.53832 12.1765C1.55673 12.5494 1.70493 12.9041 1.95725 13.1792L4.98446 16.4816C5.28686 16.812 5.71406 17 6.16286 17H9.85967C11.7797 17 13.0597 15.4 13.0597 13.8V6.94314C13.0597 5.11433 10.6597 5.11433 10.6597 6.94314V7.39994",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6595 7.40002V6.02881C10.6595 4.20001 8.25949 4.20001 8.25949 6.02881V7.40002V5.40001C8.25949 3.57121 5.85948 3.57121 5.85948 5.40001V7.40002V2.1992C5.85927 1.88108 5.73274 1.57606 5.50772 1.35119C5.2827 1.12632 4.9776 1 4.65948 1C4.34122 1 4.03599 1.12643 3.81095 1.35147C3.5859 1.57652 3.45947 1.88174 3.45947 2.2V11.4",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.1b0bc93d789a766fc0ee6877b2513479.svg";
export { ForwardRef as ReactComponent };